import React from 'react';

/**
 * Catches render/lifecycle errors in the subtree so a single crashing page
 * shows a readable error instead of whiting out the entire app.
 * Reset on navigation via the `resetKey` prop (pass the current pathname).
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary] caught render error:', error, info);
  }

  componentDidUpdate(prevProps) {
    // Clear the error when the route changes so the next page can render.
    if (this.state.error && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ error: null, info: null });
    }
  }

  render() {
    const { error, info } = this.state;
    if (!error) return this.props.children;

    return (
      <div style={{ padding: '32px', maxWidth: 900 }}>
        <div className="card" style={{ borderLeft: '4px solid var(--color-danger-500, #dc2626)' }}>
          <h2 style={{ margin: '0 0 8px', fontSize: 18, color: 'var(--color-danger-500, #dc2626)' }}>
            This page hit an error
          </h2>
          <p style={{ margin: '0 0 16px', fontSize: 13, color: 'var(--muted, #64748b)' }}>
            The rest of the app is fine — you can navigate away. Details below (also in the browser console).
          </p>
          <pre style={{
            whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontSize: 12,
            background: 'var(--surface-2, #f1f5f9)', color: 'var(--ink, #0f172a)',
            padding: 12, borderRadius: 8, overflowX: 'auto',
          }}>
            {String(error && (error.stack || error.message || error))}
            {info && info.componentStack ? '\n\nComponent stack:' + info.componentStack : ''}
          </pre>
          <button
            className="btn btn-secondary btn-sm"
            style={{ marginTop: 12 }}
            onClick={() => this.setState({ error: null, info: null })}
          >
            Try again
          </button>
        </div>
      </div>
    );
  }
}
